export default "__VITE_ASSET__DsNJOc_F__"